import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  pure,
  compose,
  lifecycle,
  withProps,
  withState,
  withHandlers
} from 'recompose';
import { withErrors, withModal } from 'recompose-extends';
import { getToken } from '../../../utils/apiUser';

import Header from '../../containers/Header';
import { TemplateMultimediaFullScreen } from './Templates';
import TemplateBase from './Templates/TemplateBase';
import { checkTemplateId } from './Templates/Template';
import { FULLWIDTH } from '../../../constants/templates';
import {
  getImageLink,
  getImageVideoPath,
  videoUrl
} from '../../../utils/resources';
import GalleryFullScreen from '../../core/GalleryFullScreen';
import AuxDiv from '../../core/AuxDiv';
import NewsComments from '../../containers/New/NewsComments';

const videoSources = [];

const NewsArticle = ({
  templateId,
  mediaType,
  baseContentType,
  imageSrc,
  videoSrc,
  socialInfo,
  modalFullSize,
  id,
  location,
  like,
  likesNumber,
  onLikeHandler,
  likesNumberState,
  setLikesNumberState,
  onLike,
  ...rest
}) => {
  const [hasToken, setHasToken] = useState(false);
  useEffect(() => {
    getToken().then(data => setHasToken(data.access_token.length > 1));
  }, []);
  return (
    <AuxDiv>
      <Header />
      {checkTemplateId(templateId, FULLWIDTH) && (
        <TemplateMultimediaFullScreen mediaType={mediaType} src={imageSrc} />
      )}
      <TemplateBase
        id={id}
        templateId={templateId}
        mediaType={mediaType}
        baseContentType={baseContentType}
        src={imageSrc || videoSrc}
        likesNumber={likesNumberState}
        onLike={onLikeHandler}
        like={like}
        hastoken={hasToken}
        {...rest}
      />
      <NewsComments
        id={id}
        numComments={socialInfo?.numberOfComments}
        location={location}
      />
    </AuxDiv>
  );
};
NewsArticle.propTypes = {
  templateId: PropTypes.string,
  baseContentType: PropTypes.string,
  mediaType: PropTypes.string,
  imageSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  videoSrc: PropTypes.shape({
    imgThumb: PropTypes.string,
    imgPoster: PropTypes.string,
    id: PropTypes.number
  }),
  id: PropTypes.string,
  socialInfo: PropTypes.shape({
    numberOfComments: PropTypes.number
  })
};

export default compose(
  withErrors(),
  withState('modalFullSize', 'setModalFullSize', false),
  withState(
    'likesNumberState',
    'setLikesNumberState',
    props => props.socialInfo?.likesNumber
  ),
  withProps(({ clientPath, video, mediaId, galleryImageClientPaths }) => ({
    imageSrc:
      getImageLink(clientPath) ||
      (galleryImageClientPaths &&
        galleryImageClientPaths.map(image => getImageLink(image))),
    videoSrc: video && {
      imgThumb: getImageVideoPath(video.imgPoster, '1239x697'),
      imgPoster: getImageVideoPath(video.imgPoster, '1239x697'),
      id: mediaId,
      duration: Math.floor(video.duration),
      tipo: 'VIDEO',
      playondraw: false,
      titulo: '',
      sources: videoSources
    }
  })),
  withHandlers({
    onToggleFullSize: ({ setModalFullSize, modalFullSize }) => () => {
      setModalFullSize(!modalFullSize);
      document.body.style.overflow = modalFullSize ? 'auto' : 'hidden';
    },
    onLikeHandler: props => () => {
      const likesNumberStateUpdated = props.like
        ? props.likesNumberState - 1
        : props.likesNumberState + 1;
      props.setLikesNumberState(likesNumberStateUpdated);
      props.onLike(props.id);
    }
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.mediaType === 'VIDEO') {
        videoUrl(this.props.mediaId).then(response =>
          videoSources.push({
            src: response.sources.hls,
            type: response.sources.type
          })
        );
      }
    }
  }),
  withModal(
    ({ modalFullSize }) => modalFullSize,
    GalleryFullScreen,
    ({ onToggleFullSize, title, subtitle, author, imageSrc }) => ({
      onClose: () => onToggleFullSize(),
      title,
      subtitle,
      author: author.user.name,
      images: imageSrc
    })
  ),
  pure
)(NewsArticle);
